if (typeof window.SaveForLater == 'undefined') {
  window.SaveForLater = {
    empty: true,
  };
}

SaveForLater.init = function (swat) {
  SaveForLater.swat = swat;

  SaveForLater.fetchListData();
};

SaveForLater.reloadElements = function () {
  SaveForLater.loaded = false;

  SaveForLater.fetchListData();
};

SaveForLater.fetchListData = function () {
  let onSuccess = function (response) {
    SaveForLater.listId = response.list.lid;

    SaveForLater.fetchList().then((list) => {
      SaveForLater.list = list;
      SaveForLater.loaded = true;
    });
  };

  let onError = function (error) {
    console.error('There was an Error, while creating the Save For Later List', error);
  };

  SaveForLater.swat.SaveForLater.init(onSuccess, onError);
};

SaveForLater.fetchList = function () {
  return new Promise((resolve, reject) => {
    const onSuccess = async (list) => {
      resolve(list);
    };

    const onError = (error) => {
      console.error('There was an Error, while we tried to fetch the Save For Later List');
      reject(error);
    };

    SaveForLater.swat.SaveForLater.fetch(SaveForLater.listId, onSuccess, onError);
  });
};

SaveForLater.removeFromList = function (products) {
  return new Promise((resolve, reject) => {
    let onSuccess = async function (deletedProduct) {
      SaveForLater.reloadElements();
      Wishlist.reloadElements();

      resolve(deletedProduct);
    };

    let onError = function (error) {
      console.error('Error while removing product from Save for Later', error);
      reject(error);
    };

    SaveForLater.swat.SaveForLater.remove(SaveForLater.listId, products, onSuccess, onError);
  });
};

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(SaveForLater.init);

if (!customElements.get('save-for-later')) {
  customElements.define(
    'save-for-later',
    class SwymSaveForLater extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.productUrl = this.dataset.productUrl;
        this.productHandle = this.dataset.productHandle;
        this.index = this.dataset.index;

        this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

        this.addEventListener('click', this.saveForLater.bind(this));
      }

      saveForLater() {
        if (!SaveForLater.swat) {
          console.warn('[ SwymSaveForLater.saveForLater() ] :: Swym SDK is not loaded, unable to save for later.');
          return;
        }

        const products = [
          {
            du: this.productUrl,
            empi: this.productId,
            epi: this.variantId,
          },
        ];

        const parent = this;

        let onSuccess = function (response) {
          parent.cartItems.updateQuantity(parent.index, 0);
        };

        let onError = function (error) {
          console.error('There was an Error, while Adding products to the Save For Later List', error);
        };

        SaveForLater.swat.SaveForLater.add(SaveForLater.listId, products, onSuccess, onError);
      }
    }
  );
}
